/**
 * Constantes e validadores compartilhados pelo módulo de documentos
 * de diligência. Mantidos em arquivo separado para manter compatibilidade
 * com `react-refresh/only-export-components` em `useDiligenciaDocuments.tsx`.
 *
 * Sprint 4 — S4.2 (multi-upload).
 */

/** Quantidade máxima de arquivos por checklist key. */
export const MAX_FILES_PER_CHECKLIST = 10;

/** Tamanho máximo por arquivo, em MB. */
export const MAX_FILE_SIZE_MB = 25;

/** Tamanho máximo por arquivo, em bytes (derivado de MAX_FILE_SIZE_MB). */
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

/** MIME types aceitos para upload de documentos de diligência. */
export const ACCEPTED_MIME_TYPES = ['application/pdf'] as const;

/**
 * Valida um único arquivo contra as regras client-side de multi-upload.
 * Retorna `null` se válido, ou string de erro pt-BR caso contrário.
 */
export function validateDiligenciaFile(file: File): string | null {
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return `Arquivo "${file.name}" excede o limite de ${MAX_FILE_SIZE_MB} MB.`;
  }

  const isPdfMime = ACCEPTED_MIME_TYPES.includes(
    file.type as (typeof ACCEPTED_MIME_TYPES)[number]
  );
  const isPdfExt = file.name.toLowerCase().endsWith('.pdf');
  if (!isPdfMime && !isPdfExt) {
    return `Arquivo "${file.name}" não é PDF. Apenas PDF é aceito.`;
  }

  return null;
}
